import {FixFlickity} from "//www.feed.co/cdn/shop/t/8/assets/helpers.js?v=132700998466281914211734605445";
export class LandingSliderSection extends HTMLElement {
  connectedCallback() {
    let that = this;
    this._attachListeners();

    if (window.matchMedia('(min-width: 1024px)').matches) {
      window.addEventListener('load', function() {
        that._initSlider();
      })
    }
  }

  _attachListeners() {
    let that = this;
    window.matchMedia('(min-width: 1024px)').addEventListener('change', () => {
      that._responsiveContent();
    })
  }

  /**
   * Init Sliders
   */
  _initSlider() {
    let that = this;

    //fix Flickity slider
    new FixFlickity();

    this.slider = new Flickity(this.querySelector('.page__landing-slider'), {
      cellAlign: 'left',
      groupCells: true,
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      freeScroll: true,
      on: {
        ready: function () {
          // inject arrows
          this.prevButton.element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="#262626" stroke-miterlimit="10" stroke-width="2" d="M0 8h14"></path><path stroke="#262626" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" d="M8 2l6 6-6 6"></path></svg>';
          this.nextButton.element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="#262626" stroke-miterlimit="10" stroke-width="2" d="M0 8h14"></path><path stroke="#262626" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" d="M8 2l6 6-6 6"></path></svg>';
        }
      }
    });

    this.querySelectorAll('.page__landing-section-products-collection-wrapper .product-item__wrapper').forEach(item => {
      item.style.height = '100%';
    });

    setTimeout(function() {
      that.slider.resize();
    }, 300);

    /*
    Flickity.prototype._createResizeClass = function() {
      this.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    let resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.classList.remove('flickity-resize');
      resize.call(this);
      this.classList.add('flickity-resize');
    };
    */

  }

  /**
   * Manage responsive content
   */
  _responsiveContent() {
    if (window.matchMedia('(max-width: 1023px)').matches) {
      if (this.slider) {
        this.slider.destroy();
      }
    } else {
      this._initSlider();
    }
  }

}
try {
  window.customElements.define('landing-slider-section', LandingSliderSection);
} catch(e) {}